import { EditUserForm } from '@/bundle/shared/components/EditUserForm/EditUserForm';
import { AssignExecutorForm } from './AssignExecutorForm';
import { USER_ROLE_MAP } from '@/const/user';
import { AssignedWireType } from '@/types/wireTypes';

type ExecutorActionsWidgetType = {
  wire: AssignedWireType;
  onRefetchWire: () => void;
  isShowAssignForm: boolean;
  showExecutorEditFormIds: {
    [id: string]: boolean;
  };
  onCloseAssignForm: () => void;
  onCloseEditForm: (id: string) => void;
};

const getHeader = (executorCount: number) => {
  return executorCount ? `Assign Executor ${++executorCount}` : 'Assign Executor 1';
};

const getSubHeader = (executorCount: number) => {
  return executorCount ? (
    'Please indicate who will mark this wire as executed.'
  ) : (
    <>
      Please indicate who will mark this wire as executed.
      <br />
      You will be able to assign one more Executor later.
    </>
  );
};

export const ExecutorActionsWidget = ({
  wire,
  isShowAssignForm,
  showExecutorEditFormIds,
  onCloseAssignForm,
  onCloseEditForm,
  onRefetchWire,
}: ExecutorActionsWidgetType) => {
  const executors = wire?.assigned_executors || [];

  const editableExecutor = executors.find((executor) => showExecutorEditFormIds[executor?.id]);
  let selectedExecutorIndex = executors.findIndex((executor) => editableExecutor?.id === executor?.id);

  const header = getHeader(executors.length);
  const subHeader = getSubHeader(executors.length);

  const createOrAssignExecutor = () => {
    onCloseAssignForm();
    onRefetchWire();
  };

  const editExecutorHeader = `Edit Executor ${++selectedExecutorIndex}`;
  const user = editableExecutor?.user;

  return (
    <>
      {isShowAssignForm && (
        <AssignExecutorForm
          onCreateExecutor={createOrAssignExecutor}
          onAssignExecutor={createOrAssignExecutor}
          onClose={onCloseAssignForm}
          header={header}
          subHeader={subHeader}
        />
      )}

      {editableExecutor && (
        <EditUserForm
          header={editExecutorHeader}
          role={USER_ROLE_MAP.EXECUTOR}
          user={user}
          wireId={wire?.id}
          onClose={() => onCloseEditForm(user?.id)}
          onSuccess={onRefetchWire}
          executorId={editableExecutor?.id}
        />
      )}
    </>
  );
};
